var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08036 1.57061C9.30905 -0.523538 12.3367 -0.523538 13.5654 1.57061L14.304 2.82946C14.8708 3.79556 15.9042 4.39215 17.0242 4.4L18.4837 4.41022C20.9117 4.42722 22.4255 7.04924 21.2263 9.1604L20.5054 10.4295C19.9521 11.4034 19.9521 12.5966 20.5054 13.5705L21.2263 14.8396C22.4255 16.9508 20.9117 19.5728 18.4837 19.5898L17.0242 19.6C15.9042 19.6078 14.8708 20.2044 14.304 21.1705L13.5654 22.4294C12.3367 24.5235 9.30905 24.5235 8.08036 22.4294L7.34176 21.1705C6.77493 20.2044 5.7416 19.6078 4.62152 19.6L3.16202 19.5898C0.734086 19.5728 -0.779737 16.9508 0.419506 14.8396L1.1404 13.5705C1.69365 12.5966 1.69365 11.4034 1.1404 10.4295L0.419506 9.1604C-0.779737 7.04924 0.734086 4.42722 3.16202 4.41022L4.62152 4.4C5.7416 4.39215 6.77493 3.79556 7.34176 2.82946L8.08036 1.57061Z",
    fill: "url(#paint0_linear_12533_21177)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 8.82031L9.23302 14.6498L6.58325 12",
    stroke: "#493B15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12533_21177",
    x1: 0,
    y1: 0,
    x2: 25.0279,
    y2: 5.22346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F7E47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F1C855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFE2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE970"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProactive);
export default __webpack_public_path__ + "static/media/proactive.31cf141bea84a0b0866bf7b2eb042267.svg";
export { ForwardRef as ReactComponent };